import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

const checkAuthStatus = () => {
  try {
    const token = localStorage.getItem('authToken');
    const userData = localStorage.getItem('userData');

    console.log('🔍 Checking auth status:', {
      hasToken: !!token,
      token: token ? token.substring(0, 20) + '...' : 'none',
      hasUserData: !!userData
    });

    if (token && userData) {
      return {
        isAuthenticated: true,
        user: JSON.parse(userData)
      };
    }

    return {
      isAuthenticated: false,
      user: null
    };
  } catch (error) {
    console.error('❌ Error checking auth:', error);
    return {
      isAuthenticated: false,
      user: null
    };
  }
};

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState(() => {
    const auth = checkAuthStatus();
    console.log('🚀 AuthProvider initializing with:', auth);
    return {
      isAuthenticated: auth.isAuthenticated,
      user: auth.user,
      isLoading: false
    };
  });

  const [isAuthenticated, setIsAuthenticated] = useState(authState.isAuthenticated);
  const [user, setUser] = useState(authState.user);
  const [isLoading, setIsLoading] = useState(authState.isLoading);

  useEffect(() => {
    console.log('✅ AuthProvider mounted with state:', {
      isAuthenticated,
      user: user?.email || 'none',
      isLoading
    });
  }, []);

  const login = (userData, token) => {
    console.log('✅ Login called:', { email: userData?.email, hasToken: !!token });

    try {
      localStorage.setItem('authToken', token);
      localStorage.setItem('userData', JSON.stringify(userData));

      setUser(userData);
      setIsAuthenticated(true);

      console.log('✅ Login successful, localStorage updated');
    } catch (error) {
      console.error('❌ Login error:', error);
    }
  };

  const logout = () => {
    console.log('🚪 Logout called');

    try {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');

      setUser(null);
      setIsAuthenticated(false);

      console.log('✅ Logout successful');
    } catch (error) {
      console.error('❌ Logout error:', error);
    }
  };

  useEffect(() => {
    console.log('🔄 Auth state updated:', {
      isAuthenticated,
      user: user?.email || 'none',
      isLoading
    });
  }, [isAuthenticated, user, isLoading]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
